import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import * as THREE from 'three';

export function WatchPlaceholder({ progress }: { progress: number }) {
  const group = useRef<THREE.Group>(null);
  const seconds = useRef<THREE.Mesh>(null);
  useFrame(({ clock }, delta) => {
    if (!group.current) return;
    const reveal = THREE.MathUtils.smoothstep(progress, 0.62, 0.72);
    group.current.visible = reveal > 0.01;
    group.current.scale.setScalar(reveal * 1.2);
    group.current.rotation.y += delta * 0.12;
    group.current.rotation.x = -0.4 + Math.sin(clock.elapsedTime * 0.35) * 0.08;
    if (seconds.current) seconds.current.rotation.z = -clock.elapsedTime * Math.PI / 30;
  });
  return (
    <group ref={group} position={[0, 0, 0]} rotation={[-0.4, 0.5, 0]}>
      <mesh>
        <cylinderGeometry args={[1.55, 1.55, 0.34, 96]} />
        <meshStandardMaterial color="#aeb3b7" metalness={0.92} roughness={0.18} />
      </mesh>
      <mesh position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]}>
        <circleGeometry args={[1.31, 96]} />
        <meshStandardMaterial color="#111419" metalness={0.25} roughness={0.64} />
      </mesh>
      <mesh position={[0, 0.39, 0]} rotation={[Math.PI / 2, 0, 0]}>
        <torusGeometry args={[1.38, 0.16, 24, 96]} />
        <meshStandardMaterial color="#17191b" metalness={0.75} roughness={0.28} />
      </mesh>
      <mesh ref={seconds} position={[0, 0.43, 0]} rotation={[Math.PI / 2, 0, 0]}>
        <boxGeometry args={[0.025, 1.1, 0.02]} />
        <meshStandardMaterial color="#a3211f" emissive="#4b0707" emissiveIntensity={1.5} />
      </mesh>
      <mesh position={[0.33, 0.44, 0]} rotation={[Math.PI / 2, 0, -0.35]}>
        <boxGeometry args={[0.08, 0.9, 0.05]} />
        <meshStandardMaterial color="#c5a267" metalness={0.8} roughness={0.18} />
      </mesh>
      <mesh position={[-0.15, 0.45, 0]} rotation={[Math.PI / 2, 0, 0.8]}>
        <boxGeometry args={[0.11, 0.65, 0.06]} />
        <meshStandardMaterial color="#c5a267" metalness={0.8} roughness={0.18} />
      </mesh>
    </group>
  );
}
